export const Fields = {
    OLD_PASSWORD: 'oldPassword',
    NEW_PASSWORD: 'newPassword',
};

export const Forms = {
    CHANGE_PASSWORD: 'changePassword',
};
